/**
 * Lore de « l'Île des Défis » — SOURCE UNIQUE des éléments narratifs.
 * Récit : l'île de Tano (le tuit-tuit de la Roche Écrite) s'est ENDORMIE ;
 * l'élève la RÉVEILLE en gagnant de l'énergie (quiz + défis). Le volcan
 * gronde puis érupte, la forêt rechantera… La brume n'est plus qu'un visuel
 * de verrouillage (« Bientôt ✨ »), pas un récit.
 *
 * Tout est AFFICHAGE : aucun impact sur XP/quota/scoring (back souverain).
 */

// ── Paliers nommés : le niveau XP devient une ASCENSION de l'île ──────────
// (lagon → sommets). Affichés dans HeaderEleve, MoiEleve et au level-up.
const PALIERS = [
    { min: 1, nom: 'Marmaille du Lagon', emoji: '🌊' },
    { min: 4, nom: 'Explorateur des Bas', emoji: '🥾' },
    { min: 7, nom: 'Marcheur des Cirques', emoji: '⛰️' },
    { min: 10, nom: 'Gardien de la Forêt', emoji: '🌳' },
    { min: 14, nom: 'Maître du Volcan', emoji: '🌋' },
    { min: 18, nom: 'Légende du Piton', emoji: '❄️' },
];

/** Titre du palier pour un niveau XP (repli : 1er palier). */
export const nomPalier = (niveau) => {
    const n = Number(niveau) || 1;
    let courant = PALIERS[0];
    for (const p of PALIERS) { if (n >= p.min) courant = p; }
    return courant;
};

// ── Noms d'aventure des PORTAILS du volcan (mappés sur les thèmes réels) ──
// Le nom officiel du thème reste visible dans la FicheDefi (le lien avec le
// programme n'est jamais perdu) ; le portail, lui, vend du rêve.
const PORTAILS_LORE = [
    { cles: ['géom', 'espace'], nom: 'Le Temple des Formes', ico: '📐' },
    { cles: ['grandeur', 'mesure'], nom: 'L\'Atelier des Mesures', ico: '⚖️' },
    { cles: ['donnée', 'gestion'], nom: 'La Mine des Données', ico: '💎' },
    { cles: ['proportion'], nom: 'La Forge des Proportions', ico: '⚒️' },
    { cles: ['nombre', 'calcul'], nom: 'La Caverne des Calculs', ico: '🧮' },
    { cles: ['algorith', 'informat'], nom: 'Le Laboratoire des Algorithmes', ico: '⚙️' },
];

/** { nom, ico } d'aventure pour un thème — repli : nom réel + 🔮. */
export const lorePortail = (nomTheme = '') => {
    const s = String(nomTheme).toLowerCase();
    const hit = PORTAILS_LORE.find((p) => p.cles.some((c) => s.includes(c)));
    return hit ? { nom: hit.nom, ico: hit.ico } : { nom: nomTheme, ico: '🔮' };
};
